import React from "react";
import Image from "next/image";
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";
import styles from "./acheiver.module.css";
import pic1 from "../../assets/images/home/Shri_Shaurya_Arora-2023.png";
import pic2 from "../../assets/images/home/YAKSH-CHAUDHARY.png";
import pic3 from "../../assets/images/home/Ishita-Kishore-2022.png";
import pic4 from "../../assets/images/home/RAJESHWARI-SUVE-M.png";
import pic01 from "../../assets/images/home/SIVACHANDRAN.png";
// import pic6 from "../../assets/images/home/16-AYANJAIN.png";
import Link from "next/link";

const  acheiverslist=[
    { aos: "zoom-in", delay: "100", Image: pic4, alt: "RAJESHWARI SUVE M", name: "RAJESHWARI SUVE M", dept: "AIR 2", class:"img-fluid",cont: "CivilIASation - 2025"},
    { aos: "zoom-in", delay: "200", Image: pic01 , name: "B SIVACHANDRAN",  alt: "B SIVACHANDRAN",  dept: "AIR 23", class:"img-fluid",cont: (<><span className="text-center">SIA Mains</span><span className="text-center">Civiliasation-2024</span></>)},
    { aos: "zoom-in", delay: "300", Image: pic1 , alt: "SHAURYA ARORA", name: "SHAURYA ARORA", dept: "AIR 14", class:"img-fluid",cont: "Civiliasation-2023"},
    { aos: "zoom-in", delay: "400", Image: pic3 , alt: "ISHITA KISHORE", name: "ISHITA KISHORE", dept: "AIR 1", class:"img-fluid",cont: "Civiliasation-2022"},
    { aos: "zoom-in", delay: "500", Image: pic2 , alt: "YAKSH CHAUDHARY", name: "YAKSH CHAUDHARY", dept: "AIR 06", class:"img-fluid",cont: "Mainstorming-2021"},
   
]

const acheiver=()=>{

   useEffect(() => {
   AOS.init({
     duration: 800,
     easing: "ease-in-out",
     once: true,
     offset: 100,
   });
 }, []);

  
  return(
    <>
      <div className="container">
        <div className="row">
          <div className="col pt-3">
            <div className={styles.scrollparent}>

              {acheiverslist.map((item, index) => (
                <div
                  key={index}
                  className={styles.scrolldiv}
                  data-aos={item.aos}
                  data-aos-delay={item.delay}
                >

                  <span className={styles.redStrip}></span>

                  <div className={styles.imageBox}>
                    <Image
                      src={item.Image}
                      alt={item.alt}
                      className={styles.avatar}
                    />
                  </div>

                  <div className={styles.imageWrapper}>
                    <p>{item.name}</p>
                    <p>{item.name1}</p>
                    <p>{item.dept}</p>

                    <p className={`${styles.acheiverrank} text-center`}>
                      {item.cont}
                    </p>
                  </div>

                </div>
              ))}

            </div>
          </div>
        </div>

        <div className="row">
          <div className="col pt-5 pb-4 text-center">
            <Link href="/our-achievers" className={styles.viewbuttonalink}>
              <button type="button" className={styles.viewbutton}>
                View All
              </button>
            </Link>
          </div>
        </div>
      </div>
    </>
    )
}
export default acheiver;